const career = {
  career: {
    title: "Career that suits you",
    visionaries: "Visionaries",
    lifekeepers: "Lifekeepers",
    educators: "Educators",
    strategists: "Strategists",
    architects: "Architects",
    stewards: "Stewards",
    guardians: "Guardians",
    vanguards: "Vanguards",
    advisors: "Advisors",
    careerCount: "Career Count",

    // Career translations from career_analysis.ts
    // 紫微
    高级品: "Luxury Goods",
    珍贵细致物品: "Precious Items",
    珠宝: "Jewelry",
    钟表: "Watches & Clocks",
    医疗管理: "Medical Management",
    房地产: "Real Estate",
    专业技能: "Professional Skills",
    公职: "Public Service",
    策略顾问: "Strategic Consulting",
    高阶主管: "Senior Management",
    行政官员: "Administrative Officials",
    品牌顾问: "Brand Consulting",

    // 武曲
    金融业: "Finance Industry",
    金属业: "Metal Industry",
    财经业: "Financial Business",
    保险: "Insurance",
    银行: "Banking",
    采矿业: "Mining Industry",
    生产制造: "Manufacturing",
    会计: "Accounting",
    投资理财: "Investment Management",
    资产管理: "Asset Management",
    企业财务顾问: "Corporate Financial Advisor",

    // 廉贞
    艺术创作: "Artistic Creation",
    管理业: "Management",
    行政: "Administration",
    律师: "Legal Profession",
    军警系统: "Military & Police",
    种植业: "Agriculture",
    水果批发: "Fruit Wholesale",
    创意产业: "Creative Industry",
    装潢设计: "Interior Design",
    广告营销: "Advertising & Marketing",
    时尚相关: "Fashion-related",

    // 贪狼
    表演艺术: "Performing Arts",
    重工业: "Heavy Industry",
    特殊技能: "Specialized Skills",
    医疗手术: "Medical Surgery",
    娱乐业: "Entertainment Industry",
    摄影: "Photography",
    直播主: "Live Streaming",
    舞蹈: "Dance",
    公关: "Public Relations",
    星探: "Talent Scout",
    网红经济: "Internet Celebrity Economy",
    音乐制作: "Music Production",

    // 破军
    工程拆除: "Demolition Engineering",
    装修工程: "Renovation Engineering",
    市场开发: "Market Development",
    仓储物流: "Warehouse Logistics",
    混乱行业: "Chaotic Industries",
    跳蚤市场: "Flea Market",
    车辆改装: "Vehicle Modification",
    船务公司: "Shipping Company",
    救灾重建: "Disaster Recovery",
    问题解决顾问: "Problem-solving Consultant",

    // 七杀
    原料买卖: "Raw Material Trading",
    建材: "Building Materials",
    教育培训: "Education & Training",
    纸业: "Paper Industry",
    酒吧: "Bars & Nightlife",
    情色行业: "Adult Industry",
    演艺事业: "Performance Industry",
    肉品加工: "Meat Processing",
    屠宰业: "Slaughtering Industry",
    美容美发: "Beauty & Hair Styling",
    宗教传教: "Religious Missionary",
    创业顾问: "Entrepreneurial Consultant",

    // 巨门
    语言沟通: "Language Communication",
    演讲: "Public Speaking",
    地下医疗: "Underground Medical",
    命理咨询: "Fortune Telling",
    法务助理: "Legal Assistant",
    中介买卖: "Intermediary Trading",
    翻译: "Translation",
    新闻传播: "News Media",
    网评员: "Internet Commentator",
    争议解决专家: "Dispute Resolution Expert",

    // 天府
    衣食住行行业: "Essential Industries",
    畜牧业: "Animal Husbandry",
    稳定性企业: "Stable Enterprises",
    农业行政: "Agricultural Administration",
    营养品销售: "Nutritional Sales",
    家庭服务: "Home Services",

    // 天相
    餐饮业: "Food & Beverage",
    职业服饰: "Professional Clothing",
    饭店管理: "Hotel Management",
    餐饮顾问: "Catering Consultant",
    清洁行业: "Cleaning Industry",
    饭店前台: "Hotel Reception",
    接待: "Reception",
    软性服务: "Soft Services",
    美容护理: "Beauty Care",

    // 天机
    机械制造: "Mechanical Manufacturing",
    工程设备: "Engineering Equipment",
    交通工具: "Transportation",
    策划设计: "Planning & Design",
    研究分析: "Research & Analysis",
    批发行: "Wholesale Industry",
    技术研发: "Technical R&D",
    软件工程: "Software Engineering",
    工程顾问: "Engineering Consultant",
    AI开发: "AI Development",

    // 天同
    服务业: "Service Industry",
    饮料业: "Beverage Industry",
    幼教: "Early Childhood Education",
    小孩用品: "Children's Products",
    小吃餐饮: "Snack Food",
    自由职业: "Freelance",
    轻松工作: "Relaxed Work",
    美容保健: "Beauty & Health",
    服饰零售: "Clothing Retail",
    百货公司: "Department Store",
    园艺设计: "Garden Design",

    // 天梁
    中医药: "Traditional Chinese Medicine",
    药品销售: "Pharmaceutical Sales",
    医护人员: "Medical Staff",
    政府单位: "Government Units",
    养老服务: "Elderly Care Services",
    社工: "Social Work",
    长照服务: "Long-term Care",
    志工组织: "Volunteer Organizations",

    // 太阴
    出租业: "Rental Business",
    高级汽车: "Luxury Cars",
    清洁服务: "Cleaning Services",
    旅馆业: "Hotel Industry",
    女性产品: "Women's Products",
    化妆品: "Cosmetics",
    床具销售: "Bedding Sales",
    月子中心: "Maternity Center",
    文创产品: "Cultural Creative Products",

    // 太阳
    名牌销售: "Luxury Brand Sales",
    政治工作: "Political Work",
    外交: "Diplomacy",
    国际贸易: "International Trade",
    能源事业: "Energy Industry",
    媒体公关: "Media PR",
    宣传传播: "Promotional Communication",
    教育辅导: "Educational Tutoring",
    光电产业: "Optoelectronic Industry",

    // 文昌
    文书处理: "Document Processing",
    教育业: "Education Industry",
    出版印刷: "Publishing & Printing",
    礼品设计: "Gift Design",
    图书馆管理: "Library Management",
    行政助理: "Administrative Assistant",
    编剧写作: "Scriptwriting",
    研究单位: "Research Units",

    // 文曲
    文学创作: "Literary Creation",
    艺术设计: "Art Design",
    文化创意: "Cultural Creation",
    礼仪顾问: "Etiquette Consultant",
    文艺表演: "Literary Performance",
    讲师: "Lecturer",
    作家: "Writer",
    演讲者: "Speaker",
    装潢策划: "Decoration Planning",

    // 左辅
    辅助人员: "Support Staff",
    助理: "Assistant",
    咨询顾问: "Consulting Advisor",
    教学辅助: "Teaching Assistant",
    团队协调: "Team Coordination",
    中间人: "Intermediary",
    幕后策划: "Behind-the-scenes Planning",

    // 右弼
    顾问: "Advisor",
    辅助岗位: "Support Position",
    人事行政: "HR Administration",
    方向指导: "Direction Guidance",
    辅助决策: "Decision Support",
    计划执行: "Plan Execution",
  },
};

export default career;
